(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.isManagedByGroup = false;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Check if managed by StickyGroupManager (set after manager initializes)
      // Use MutationObserver to detect when managedByGroup attribute is set
      this.checkManagedStatus();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      // Listen for sticky events from StickyGroupManager
      this.addEventListener('stickyHide', this.onManagedHide.bind(this));
      this.addEventListener('stickyReveal', this.onManagedReveal.bind(this));
      this.addEventListener('stickyReset', this.onManagedReset.bind(this));

      // Only attach scroll handler if not managed by group
      if (!this.isManagedByGroup) {
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }
    }

    checkManagedStatus() {
      // Check if already managed
      if (this.dataset.managedByGroup === 'true') {
        this.isManagedByGroup = true;
        return;
      }

      // Watch for the attribute to be set by the manager
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'data-managed-by-group' && this.dataset.managedByGroup === 'true') {
            this.isManagedByGroup = true;
            // Remove scroll handler if it was attached
            if (this.onScrollHandler) {
              window.removeEventListener('scroll', this.onScrollHandler);
            }
            observer.disconnect();
          }
        });
      });

      observer.observe(this, { attributes: true });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      if (this.onScrollHandler) {
        window.removeEventListener('scroll', this.onScrollHandler);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      // Skip if managed by group
      if (this.isManagedByGroup) return;

      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    // Event handlers for when managed by StickyGroupManager
    onManagedHide() {
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    onManagedReveal() {
      // Any reveal-specific logic
    }

    onManagedReset() {
      // Any reset-specific logic
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["in-header"]) return;
  try {
    
document.addEventListener('click',event=>{if(event.target.closest('.in-mobile-nav a')){document.querySelectorAll('.in-mobile-nav').forEach(menu=>menu.open=false);}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["in-product"]) return;
  try {
    
document.addEventListener('click',event=>{const button=event.target.closest('[data-gallery-src]');if(!button)return;const gallery=button.closest('.in-gallery');const image=gallery.querySelector('.in-gallery-image');if(!image)return;image.removeAttribute('srcset');image.src=button.dataset.gallerySrc;image.alt=button.dataset.galleryAlt;gallery.querySelectorAll('[data-gallery-src]').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));});
(()=>{const formatMoney=(cents,format)=>{const value=cents/100;const group=(digits,sep)=>digits.replace(/\B(?=(\d{3})+$)/g,sep);const [whole,fraction]=value.toFixed(2).split('.');const rounded=String(Math.round(value));const amounts={amount:`${group(whole,',')}.${fraction}`,amount_no_decimals:group(rounded,','),amount_with_comma_separator:`${group(whole,'.')},${fraction}`,amount_no_decimals_with_comma_separator:group(rounded,'.')};return format?format.replace(/\{\{\s*(\w+)\s*\}\}/,(match,key)=>amounts[key]||amounts.amount):`$${amounts.amount}`;};
const setup=root=>{const form=root.querySelector('.in-product-form');const data=root.querySelector('[data-in-variants]');if(!form||!data||form.dataset.inSubscriptions)return;form.dataset.inSubscriptions='true';const variants=JSON.parse(data.textContent);const money=data.dataset.moneyFormat||'';const moneyWithCurrency=data.dataset.moneyCurrencyFormat||money;const find=selector=>root.querySelector(selector);const idField=form.querySelector('[name="id"]');const planField=find('[data-in-selling-plan]');const subOption=find('[data-in-sub-option]');const subRadio=subOption&&subOption.querySelector('input');const oneRadio=form.querySelector('input[name="in_purchase_type"][value="onetime"]');const note=find('[data-in-sub-note]');const modeLabel=find('[data-in-mode-label]');const oneTimeText=modeLabel?modeLabel.textContent:'';
const update=()=>{const variant=variants.find(item=>String(item.id)===String(idField.value))||variants[0];const plan=variant.plan;if(subOption)subOption.hidden=!plan;if(!plan&&subRadio&&subRadio.checked)oneRadio.checked=true;const subscribed=Boolean(plan&&subRadio&&subRadio.checked);const unit=subscribed?plan.price:variant.price;planField.value=subscribed?plan.id:'';planField.disabled=!subscribed;find('[data-in-price]').textContent=formatMoney(unit,moneyWithCurrency);const compare=find('[data-in-compare]');if(compare){const compareAt=subscribed?variant.price:variant.compare;compare.hidden=!(compareAt>unit);compare.textContent=compareAt>unit?formatMoney(compareAt,money):'';}
root.querySelectorAll('.in-pack').forEach(pack=>{const count=Number(pack.querySelector('input').value)||1;const price=pack.querySelector('[data-in-pack-price]');if(price)price.textContent=formatMoney(unit*count,money);});const oneTimePrice=find('[data-in-one-price]');if(oneTimePrice)oneTimePrice.textContent=formatMoney(variant.price,money);
if(plan){find('[data-in-sub-price]').textContent=formatMoney(plan.price,money);find('[data-in-sub-compare]').textContent=formatMoney(variant.price,money);find('[data-in-sub-name]').textContent=plan.cadence||plan.name;const save=Math.round((variant.price-plan.price)/variant.price*100);find('[data-in-sub-save]').textContent=save>0?`Save ${save}%`:'';}
if(modeLabel)modeLabel.textContent=subscribed?'Subscribe & save':oneTimeText;if(note){note.hidden=!subscribed;note.textContent=subscribed?`${plan.cadence||plan.name}. Renews automatically at ${formatMoney(plan.price,money)} per delivery, plus any shipping and taxes, until you cancel. Skip, pause, or cancel anytime.`:'';}};
form.addEventListener('change',update);update();};const run=()=>document.querySelectorAll('[data-innareve-product]').forEach(setup);if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',run);}else{run();}document.addEventListener('shopify:section:load',run);})();

  } catch(e) { console.error(e); }
})();
})();
